import Arrow from "../img/arrow_back.svg";

import "./style.scss";

const ClosedQuestion = ({ item, stateAnswer, formTemplateAnswerState, restriction, setRestriction, handleClickExit, handleStepBack, dataItemConnect }) => {
    const handleClick = (el) => {
        if (el && el.restrictionTrigger) {
            setRestriction(true);
        }
        formTemplateAnswerState([el]);
    };

    return (
        <div className="closed__question">
            <div className="closed__exit">
                <div className="title">{!restriction ? item.question : item.restrictedMessage ? item.restrictedMessage : `${restriction}`}</div>
                {restriction ? (
                    <div className={`answers__options`} onClick={() => handleClickExit()}>
                        {item && item.buttonLabel ? item.buttonLabel : "Вернуться назад"}
                    </div>
                ) : null}
            </div>
            <div className="closed__question_answers">
                {(stateAnswer && !restriction) || (dataItemConnect && !restriction) ? (
                    <div className="button__back" onClick={() => handleStepBack()}>
                        <img src={Arrow} width={18} height={18} />
                    </div>
                ) : null}
                {!restriction
                    ? item.options.map((el, index) => {
                          if (index < 2) {
                              return (
                                  <div className={`answers__options }`} key={index} onClick={() => handleClick(el)}>
                                      {el.value}
                                  </div>
                              );
                          }
                      })
                    : null}
            </div>
        </div>
    );
};

export default ClosedQuestion;
